import {
  Input,
  Box,
  Heading,
  Text,
  Button,
  theme,
  Select,
  Flex,
} from "@singita/components"

import React, { useState } from "react"
import { countries, countryStates } from "../../Availability/utils/helpers"
import { validate } from "../../Forms/utils/helpers"

export const language = {
  contactInfo: {
    headline: "Contact Information",
    labelName: "Name",
    labelSurname: "Surname",
    labelEmail: "Email",
    buttonNext: "Next",
    buttonPrev: "Previous",
  },
}

const AddressInfo = props => {
  const [errors, setErrors] = useState({})
  const { onChange, values = {}, onNext, onSetValues, onPrev } = props

  const onSubmit = async () => {
    const errors = await validate(
      [
        {
          name: "country",
          required: true,
        },
        {
          name: "city",
          required: true,
        },
        {
          name: "postalCode",
          required: true,
        },
        {
          name: "state",
          required: true,
        },
        {
          name: "address",
          required: true,
        },
      ],
      values
    )

    if (Object.keys(errors).length) {
      setErrors(errors)
    } else {
      onNext()
    }
  }

  const states = values.country ? countryStates[values.country] || [] : []

  return (
    <>
      <Heading variant="primary" mb={[1, 3]}>
        Address
      </Heading>

      <Box mb={[2]}>
        <Text size="small" fontWeight="bold">
          Select your country of residence
        </Text>
        <Select
          isSearchable
          value={countries
            .map(option => {
              return {
                label: option.name,
                value: option.code,
                key: option.code,
              }
            })
            .find(p => p.value === values.country)}
          onChange={p => {
            onSetValues({ country: p.value })
          }}
          name="country"
          bg="baseGrayVeryLight"
          title="Country"
          options={countries.map(option => {
            return {
              label: option.name,
              value: option.code,
              key: option.code,
            }
          })}
        ></Select>
        {errors.country ? (
          <Text color="statusError" size="small">
            {errors.country}
          </Text>
        ) : null}
      </Box>
      <Box mb={[2]}>
        <Text size="small" fontWeight="bold">
          Address
        </Text>
        <Input
          type="textarea"
          name="address"
          value={values.address || ""}
          onChange={onChange}
          bg={theme.colors.baseGrayVeryLight}
          title="Address"
        />
        {errors.address ? (
          <Text color="statusError" size="small">
            {errors.address}
          </Text>
        ) : null}
      </Box>
      <Box mb={[2]}>
        <Text size="small" fontWeight="bold">
          City
        </Text>
        <Input
          name="city"
          value={values.city || ""}
          onChange={onChange}
          bg={theme.colors.baseGrayVeryLight}
          title="City"
        />
        {errors.city ? (
          <Text color="statusError" size="small">
            {errors.city}
          </Text>
        ) : null}
      </Box>
      <Box mb={[2]}>
        <Text size="small" fontWeight="bold">
          State / Province
        </Text>
        {states.length ? (
          <Select
            isSearchable
            value={states
              .map(option => {
                return {
                  label: option.name,
                  value: option.code,
                  key: option.code,
                }
              })
              .find(p => p.value === values.state)}
            onChange={p => {
              onSetValues({ state: p.value })
            }}
            name="state"
            bg={theme.colors.baseGrayVeryLight}
            title="Country"
            options={states.map(option => {
              return {
                label: option.name,
                value: option.code,
                key: option.code,
              }
            })}
          ></Select>
        ) : (
          <Input
            name="state"
            disabled={!values.country}
            value={values.state || ""}
            onChange={onChange}
            bg={theme.colors.baseGrayVeryLight}
            title="State"
          />
        )}
        {errors.state ? (
          <Text color="statusError" size="small">
            {errors.state}
          </Text>
        ) : null}
      </Box>
      <Box mb={[2]}>
        <Text size="small" fontWeight="bold">
          Postal Code
        </Text>
        <Input
          name="postalCode"
          value={values.postalCode || ""}
          onChange={onChange}
          bg={theme.colors.baseGrayVeryLight}
          title="Postal Code"
        />
        {errors.postalCode ? (
          <Text color="statusError" size="small">
            {errors.postalCode}
          </Text>
        ) : null}
      </Box>
      <Flex justifyContent="space-between">
        {onPrev ? (
          <Box mt={[3]}>
            <Button
              variant="text"
              icon="angle-left"
              iconPosition="left"
              onClick={onPrev}
            >
              {language.contactInfo.buttonPrev}
            </Button>
          </Box>
        ) : (
          <Box />
        )}
        {onNext ? (
          <Box mt={[3]}>
            <Button
              variant="text"
              icon="angle-right"
              iconPosition="right"
              onClick={onSubmit}
            >
              {language.contactInfo.buttonNext}
            </Button>
          </Box>
        ) : null}
      </Flex>
    </>
  )
}

export default AddressInfo
